import React from 'react';

const TYPE_CONFIG = {
    purchase: {
        icon: 'bi-tags',
        label: 'Compra',
        class: 'text-primary'
    },
    cash: {
        icon: 'bi-cash-stack',
        label: 'Efectivo',
        class: 'text-success'
    },
    refinancing: {
        icon: 'bi-arrow-repeat',
        label: 'Refinanciación',
        class: 'text-warning'
    }
};

function LoanTypeIcon({ type }) {
    const config = TYPE_CONFIG[type] || TYPE_CONFIG.cash;

    return (
        <i className={`bi ${config.icon} ${config.class} icon-md me-2`} 
           title={config.label}></i>
    );
}

export default LoanTypeIcon; 